import React from 'react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Cookies = () => {
  return (
    <div className="min-h-screen bg-black">
      <Disclaimer />
      <Header />
      <div className="py-20 px-4 sm:px-6 lg:px-8">
        <div className="max-w-4xl mx-auto">
          <h1 className="text-4xl md:text-5xl font-bold mb-8 text-white">
            Politique des cookies
          </h1>

          <article className="glass-strong rounded-2xl p-8 md:p-12 border border-white/10 space-y-8 text-white/80 leading-relaxed">
            <section>
              <p className="mb-4">
                <strong className="text-white">Dernière mise à jour : 08 décembre 2025</strong>
              </p>
              <p className="mb-4">
                Cette politique des cookies explique ce que sont les cookies, comment nous les utilisons sur rougebets.com, et comment vous pouvez contrôler leur utilisation.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">1. Qu'est-ce qu'un cookie ?</h2>
              <p className="mb-4">
                Un cookie est un petit fichier texte stocké sur votre appareil (ordinateur, tablette, smartphone) lorsque vous visitez un site web. Les cookies permettent 
                au site de mémoriser vos actions et préférences sur une période donnée, évitant ainsi de devoir les ressaisir à chaque visite.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">2. Types de cookies que nous utilisons</h2>
              
              <h3 className="text-xl font-semibold text-white mb-3">Cookies strictement nécessaires</h3>
              <p className="mb-4">
                Ces cookies sont essentiels au fonctionnement du site et ne peuvent pas être désactivés. Ils sont généralement définis en réponse à des actions que vous 
                effectuez et qui équivalent à une demande de services, comme définir vos préférences de confidentialité, vous connecter ou remplir des formulaires.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3">Cookies de performance et d'analyse</h3>
              <p className="mb-4">
                Ces cookies nous permettent de compter les visites et les sources de trafic afin d'améliorer les performances de notre site. Ils nous aident à savoir 
                quelles pages sont les plus populaires et comment les visiteurs naviguent sur le site. Toutes les informations collectées par ces cookies sont agrégées 
                et anonymes.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3">Cookies de fonctionnalité</h3>
              <p className="mb-4">
                Ces cookies permettent au site de fournir des fonctionnalités et une personnalisation améliorées. Ils peuvent être définis par nous ou par des prestataires 
                tiers dont nous avons ajouté les services à nos pages.
              </p>

              <h3 className="text-xl font-semibold text-white mb-3">Cookies de ciblage</h3>
              <p className="mb-4">
                Ces cookies peuvent être définis sur notre site par nos partenaires publicitaires. Ils peuvent être utilisés par ces entreprises pour créer un profil de 
                vos intérêts et vous montrer des publicités pertinentes sur d'autres sites. Ils ne stockent pas directement d'informations personnelles, mais sont basés 
                sur l'identification unique de votre navigateur et de votre appareil Internet.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">3. Cookies tiers</h2>
              <p className="mb-4">
                En plus de nos propres cookies, nous pouvons également utiliser divers cookies tiers pour nous aider à analyser l'utilisation du site et améliorer nos 
                services. Ces cookies tiers incluent :
              </p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li><strong className="text-white">Google Analytics :</strong> Pour analyser l'utilisation du site et améliorer l'expérience utilisateur</li>
                <li><strong className="text-white">Réseaux sociaux :</strong> Pour permettre le partage de contenu sur les réseaux sociaux</li>
                <li><strong className="text-white">Services d'affiliation :</strong> Pour suivre les clics sur les liens d'affiliation</li>
              </ul>
              <p>
                Ces services tiers peuvent utiliser leurs propres cookies pour collecter des informations sur vos activités en ligne. Nous n'avons pas accès à ces cookies 
                ni aucun contrôle sur eux.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">4. Durée de conservation des cookies</h2>
              <p className="mb-4">
                Les cookies que nous utilisons ont différentes durées de vie :
              </p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li><strong className="text-white">Cookies de session :</strong> Supprimés automatiquement lorsque vous fermez votre navigateur</li>
                <li><strong className="text-white">Cookies persistants :</strong> Restent sur votre appareil pendant une période déterminée ou jusqu'à ce que vous les supprimiez</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">5. Comment contrôler les cookies</h2>
              <p className="mb-4">
                Vous avez le contrôle sur les cookies. La plupart des navigateurs acceptent automatiquement les cookies, mais vous pouvez modifier les paramètres de votre 
                navigateur pour refuser les cookies si vous le préférez.
              </p>
              <p className="mb-4">
                Voici comment gérer les cookies dans les principaux navigateurs :
              </p>
              <ul className="list-disc list-inside mb-4 space-y-2">
                <li><strong className="text-white">Chrome :</strong> Paramètres > Confidentialité et sécurité > Cookies et autres données de sites</li>
                <li><strong className="text-white">Firefox :</strong> Options > Vie privée et sécurité > Cookies et données de sites</li>
                <li><strong className="text-white">Safari :</strong> Préférences > Confidentialité > Cookies et données de sites web</li>
                <li><strong className="text-white">Edge :</strong> Paramètres > Cookies et autorisations de site > Cookies et données de sites</li>
              </ul>
              <p className="mb-4">
                Veuillez noter que si vous désactivez les cookies, certaines fonctionnalités du site peuvent ne pas fonctionner correctement ou ne pas être disponibles.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">6. Cookies et données personnelles</h2>
              <p className="mb-4">
                Certains cookies peuvent collecter des informations qui constituent des données personnelles. Pour plus d'informations sur la façon dont nous traitons vos 
                données personnelles, consultez notre <a href="/privacy-policy" data-discover="true" className="text-toxic-green hover:text-toxic-cyan underline">Politique de confidentialité</a>.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">7. Modifications de cette politique</h2>
              <p className="mb-4">
                Nous pouvons modifier cette politique des cookies occasionnellement pour refléter les changements dans nos pratiques ou pour d'autres raisons opérationnelles, 
                légales ou réglementaires. Toute modification sera publiée sur cette page avec une date de mise à jour révisée.
              </p>
            </section>

            <section>
              <h2 className="text-2xl md:text-3xl font-bold text-white mb-4">8. Contact</h2>
              <p className="mb-4">
                Pour toute question concernant notre utilisation des cookies, contactez-nous :
              </p>
              <ul className="list-none space-y-2">
                <li><strong className="text-white">Email :</strong> <a href="mailto:info@rougebets.com" className="text-toxic-green hover:text-toxic-cyan underline">info@rougebets.com</a></li>
                <li><strong className="text-white">Téléphone :</strong> <a href="tel:+33742963066" className="text-toxic-green hover:text-toxic-cyan underline">+33 7 42 96 30 66</a></li>
                <li><strong className="text-white">Adresse :</strong> Paris, France</li>
              </ul>
            </section>
          </article>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default Cookies;

